// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"283":"b940822c","517":"9779ab98"}[chunkId] + ".chunk.css";
};